import localStorage from 'modules/local-storage';

const setLocalStorageOnFieldChange = (value, name, setFieldValue) => {
  setFieldValue(name, value);
  localStorage.setItem(name, value);
};

const getSavedValue = (values, name, setFieldValue) => {
  const localValues = { ...values };
  let inputValue = localValues[name];

  if (typeof inputValue === 'undefined' || inputValue === '') {
    // Check for a local version
    const localValue = localStorage.getItem(name);

    // setFieldTouched(name, true, false);

    if (
      inputValue !== localValue &&
      localValue &&
      localValue !== '' &&
      name !== 'phoneNumber'
    ) {
      inputValue = localValue;
      setFieldValue(name, localValue);
    }
  }

  return inputValue;
};

export { getSavedValue, setLocalStorageOnFieldChange };
